import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';

/**
 * Thin wrapper around Auth0's AuthService (docs/KONZEPT-Developer-Platform.md —
 * same Auth0 tenant/audience as Portal-SPA for SSO, own client id).
 *
 * Deliberately leaner than Portal-SPA's PortalAuthService: this app does not track
 * tenant/role/platform-admin client-side. Authorization for every endpoint is
 * enforced server-side (Entwicklerplattform permission, token scopes) — a 403 from
 * the API is the source of truth, not a client-side role guard.
 */
@Injectable({ providedIn: 'root' })
export class DevAuthService {
  readonly isAuthenticated$ = this.auth.isAuthenticated$;
  readonly isLoading$ = this.auth.isLoading$;
  readonly user$ = this.auth.user$;

  constructor(private auth: AuthService) { }

  login(): void {
    this.auth.loginWithRedirect({
      authorizationParams: { redirect_uri: `${window.location.origin}/callback` }
    });
  }

  logout(): void {
    this.auth.logout({ logoutParams: { returnTo: window.location.origin } });
  }

  getAccessToken(): Observable<string | undefined> {
    return this.auth.getAccessTokenSilently();
  }
}
